export const HEADER_TYPE_ENHANCED = 'enhanced';
